import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { formatDate } from '../../utils';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { DescDelimiter } from './DescDelimiter';
import { Row } from './Row';
import './IssueRow.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('search-issue-row');
export function IssueRow(_ref) {
  var _item$author, _item$author2;
  var item = _ref.item,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var title = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("span", {
      className: b('key', {
        resolved: item.resolution !== 'none'
      }),
      children: [/*#__PURE__*/_jsx(Highlight, {
        text: item.id
      }), ":"]
    }), "\xA0", /*#__PURE__*/_jsx(Highlight, {
      text: item.title
    })]
  });
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("time", {
      children: formatDate(item.created)
    }), (_item$author = item.author) !== null && _item$author !== void 0 && _item$author.name ? /*#__PURE__*/_jsx(DescDelimiter, {}) : null, /*#__PURE__*/_jsx(Highlight, {
      text: (_item$author2 = item.author) === null || _item$author2 === void 0 ? void 0 : _item$author2.name
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    title: title,
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=IssueRow.js.map